<template>
  <section class="footer bg-black py-8">
    <div class="container">
      <h1 class="flex-1 text-center text-gray-400">© 2021 Movieku.</h1>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style>

</style>